import _ from "lodash";
import TableReportHelper from "report/helper";

export default function apontamentoColetasMatrizReport(
    visita,
    indicador,
    apontamento,
    extraTitles = [],
    extraColsCallback,
    extraColsWidths,
    showLocalizacao = true,
    colunas = 1

) {
    if (_.isEmpty(apontamento.coletas)) {
        return null;
    }

    const h = new TableReportHelper(apontamento);

    function extraRows(helper) {
        return extraColsCallback ? extraColsCallback(helper) : [];
    }

    const content = [
        h.panel([
            // prettier-ignore
            h.row(
                h.title("COLETAS")
            ),
        ]),
    ];

    let rTitle = []
    for (let index = 0; index < colunas; index++) {
        rTitle.push(h.title("Coleta"))
        rTitle = rTitle.concat(...extraTitles.map((content) => h.title(content)));

    }
    const coletasContent = [
        // prettier-ignore
        h.row(...rTitle),
    ];
    // let i = 1;

    // let auxColuna = 0
    let auxRow = []
    let i = 1;
    let maxColRowl = colunas * (1 + extraTitles.length)
    // console.log('maxColRowl', maxColRowl)
    for (const coleta of apontamento.coletas) {
        const r = h.helper(coleta);
        if (auxRow.length >= maxColRowl) {
            coletasContent.push(h.row(...auxRow));
            auxRow = []
        }
        auxRow.push(r.title(i)[0])
        auxRow = auxRow.concat(...extraRows(r))

        // let valueArColetasContent = []
        // valueArColetasContent.push(r.imageField("image.base64", { fit: [150, 150], }))
        // valueArColetasContent.push(r.textField("observacao"))

        // if (showLocalizacao) {
        //     valueArColetasContent.push(r.locationField("georeferencia"))
        // }

        // coletasContent.push(
        //     h.row(r.textField(i),
        //         ...extraRows(r),
        //     )
        // );
        i++
    }
    if (auxRow.length) {

        while (auxRow.length < maxColRowl) {

            auxRow.push(h.text("")[0])
        }
        coletasContent.push(h.row(...auxRow));

    }

    extraColsWidths = extraColsWidths || extraTitles.map(() => "*");
    content.push(h.panel(coletasContent));

    return content;
}
